module.exports = __webpack_public_path__ + "img/yoga.5c048670.jpg";